import { differenceInDays, format } from 'date-fns';
import { groupBy } from 'lodash';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import { Space } from '@sravni/react-design-system';

import { getDate } from '../../../helpers/news';
import { IMaterial } from '../../../interfaces/news';
import { ListContentLayout } from '../../Layouts/ListContentLayout';
import { ListGrid } from '../../ListGrid';
import { ListCard } from '../components/ListCard';
import { ListGroup } from '../components/ListGroup';
import { Trigger } from '../components/Trigger';
import { createListRenderer } from '../helpers/createListRenderer';
import { withListContainer, ListContainerProps } from '../hoc/withListContainer';

import { ListContainer } from './List';

interface Props extends Omit<React.ComponentProps<typeof ListContainer>, 'children' | 'injectConfig'> {
  injectConfig?: Record<number, JSX.Element | (Record<number, JSX.Element> & { item?: JSX.Element })>;
  children?: (group: [date: string, materials: IMaterial[]], idx: number) => JSX.Element;
}
export const getGroupTitle = (date: string) => {
  const dateDiff = differenceInDays(new Date(), new Date(date));

  if (dateDiff <= 0) {
    return '';
  }

  let title = getDate(date);

  if (dateDiff === 1) {
    title = `Вчера, ${title}`;
  }

  return title;
};

export const createDefaultRender = ({
  handleShowAuthPopup,
  card,
  withImages,
  injectConfig,
  asPath,
  createItemClickHandler,
}: Props & ListContainerProps & { asPath: string }) => ([date, group], groupIdx) => {
  return (
    <>
      <ListGroup title={getGroupTitle(date)}>
        <ListGrid>
          <>
            {createListRenderer(group, (material, index) => {
              return (
                <>
                  <ListCard
                    wrapper={ListGrid.Cell}
                    as="article"
                    index={index}
                    material={material}
                    // ** такой вид ключа очень важен для корректного отображения статей
                    key={`${material.alias}-${material.id}-${index}-${asPath}`}
                    handleShowAuthPopup={handleShowAuthPopup}
                    titleTag={index === 0 ? 'h1' : 'h2'}
                    onClick={createItemClickHandler(index, material)}
                    size="normal"
                    card={card}
                    withImage={withImages}
                  />
                  {injectConfig?.[groupIdx]?.[index]}
                </>
              );
            })}
          </>
        </ListGrid>
      </ListGroup>
      {/* @ts-ignore */}
      {React.isValidElement(injectConfig?.[groupIdx]) ? injectConfig[groupIdx] : injectConfig?.[groupIdx]?.item}
    </>
  );
};
export const DateGroupListContainer = (props: Props) => {
  const { list, children, triggerRef, injectConfig, ...layoutProps } = props;
  const { asPath } = useRouter();
  const groupedList = useMemo(() => {
    return Object.entries(groupBy(list, ({ publishDate }) => format(new Date(publishDate), 'yyyy-MM-dd')));
  }, [list]);

  //@ts-ignore
  const render = children || createDefaultRender({ ...props, asPath });

  return (
    <ListContainer list={list} {...layoutProps}>
      <ListContentLayout.Content as={Space} size={48}>
        {groupedList.map(render)}
        <Trigger ref={triggerRef} />
      </ListContentLayout.Content>
    </ListContainer>
  );
};

export const DateGroupList = withListContainer()(DateGroupListContainer);
